import { render, staticRenderFns } from "./sidenavbar.vue?vue&type=template&id=2d390796&"
import script from "./sidenavbar.vue?vue&type=script&lang=js&"
export * from "./sidenavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports